
export default {
  props: {
    navTrays: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      nextAnchor: null,
      previousAnchor: null,
      currentLink: null,
      showDropdownTl: null,
      nextContent: null,
      locationObj: {},
      postMessagePathname: '/',
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.init()
      this.buildLocationObject()

      window.addEventListener('message', this.getPostMessage, false)
      window.parent.postMessage({ message: 'Ready and waiting' }, '*')
    })
  },
  methods: {
    init() {
      // dropdown reveal timeline
      this.showDropdownTl = this.$gsap
        .timeline({
          paused: true,
          onReverseComplete: () => {
            // kill any tweens that might conflict - ex. reveal too quickly
            this.$gsap.killTweensOf([
              '.nav-item-content',
              this.wrap,
              '.anchor',
              this.$refs.menuIndicator,
              this.currentLink,
            ])
          },
        })
        .from(this.$refs.wrap, {
          autoAlpha: 0,
          // transformOrigin: '50% -50px',
          // perspective: 1000,
          // rotateX: -15,
          // yPercent: 1,
          duration: 0.3,
          ease: 'easOut',
        })
        .to(
          this.$refs.menuIndicator,
          {
            opacity: 1,
            duration: 0.2,
          },
          '<'
        )
    },
    leave() {
      this.$store.commit('setNavOpened', false)
      this.showDropdownTl.timeScale(3).reverse()
      this.nextAnchor = null
    },
    enter(e) {
      this.$store.commit('setNavOpened', true)
      this.currentLink = e.target
      this.previousAnchor = this.nextAnchor
      this.nextAnchor = e.target.querySelector('.anchor')
      this.wrap = this.$refs.wrap
      this.nextContent = this.$gsap.utils
        .toArray('.nav-item-content')
        .find((el) => el.dataset.index === this.nextAnchor?.dataset.index)

      if (!this.previousAnchor) {
        this.reveal()
      } else {
        this.previousAnchor.dataset.index !== this.nextAnchor.dataset.index &&
          this.switch()
      }
    },
    reveal() {
      // set indicator coords
      this.$gsap.set(this.$refs.menuIndicator, {
        width: this.currentLink.offsetWidth,
        x: this.currentLink.offsetLeft,
      })

      // hide rest content
      this.$gsap.set('.nav-item-content', {
        opacity: 0,
        zIndex: 1,
        pointerEvents: 'none',
      })

      // show target content
      this.$gsap.set(this.nextContent, {
        opacity: 1,
        zIndex: 2,
        pointerEvents: 'auto',
      })

      // set anchor height
      this.$gsap.set(this.nextAnchor, {
        height: this.nextContent.offsetHeight,
      })

      // capture anchor state
      const state = this.$Flip.getState(this.nextAnchor)

      // fit wrapper
      this.$Flip.fit(this.wrap, state, {
        absolute: true,
        duration: 0.01,
        ease: 'easOut',
        simple: true,
      })

      // reveal
      this.showDropdownTl.timeScale(1).restart()
    },
    switch() {
      // animate indicator
      this.$gsap.to(this.$refs.menuIndicator, {
        width: this.currentLink.offsetWidth,
        x: this.currentLink.offsetLeft,
        duration: 0.3,
        ease: 'easInOut',
      })

      // set height
      this.$gsap.set(this.nextAnchor, {
        height: this.nextContent.offsetHeight - 1,
      })

      // capture anchor state
      const state = this.$Flip.getState(this.nextAnchor, {
        props: 'height,width',
      })

      // animate wrapper to fit target anchor dimensions
      this.flip = this.$Flip.fit(this.wrap, state, {
        absolute: true,
        duration: 0.3,
        ease: 'easInOut',
        // simple: true,
      })

      // hide rest content
      this.$gsap.to('.nav-item-content', {
        opacity: 0,
        zIndex: 1,
        pointerEvents: 'none',
        duration: 0.2,
        ease: 'easOut',
        overwrite: true,
      })

      // show target content
      this.$gsap.to(this.nextContent, {
        opacity: 1,
        zIndex: 2,
        pointerEvents: 'auto',
        duration: 0.2,
        ease: 'easInOut',
        delay: 0.2,
        overwrite: true,
      })
    },
    buildLocationObject() {
      const locationObj = this.navTrays.reduce((acc, tray) => {
        const cloneObj = acc
        acc[tray.label] = [
          ...tray?.body_nav_items?.map((item) => item?.link.cached_url),
          ...tray?.footer_nav_items?.map((item) => item?.link.cached_url),
          ...tray?.submenu_nav_items?.map((item) => item?.link.cached_url),
        ]

        return cloneObj
      }, {})

      this.locationObj = locationObj
    },
    navLocationCheck(label) {
      if (this.postMessagePathname === '/') {
        return false
      }

      if (!this.locationObj[label]) {
        return false
      }

      return this.locationObj?.[label]
        ?.map((item) => item.includes(this.postMessagePathname))
        .includes(true)
    },

    getPostMessage(event) {
      if (!event.origin.includes('www.wellcertified.com')) {
        return
      }

      this.postMessagePathname = event.data?.pathname
    },
  },
}
